export type AnalyticsEvent =
  | "pathway-selected"
  | "linkedin-message-clicked"
  | "product-doc-clicked"
  | "book-gpt-clicked";

export function track(event: AnalyticsEvent, props?: Record<string, string>): void {
  if (typeof window === "undefined") return;
  const plausible = (
    window as Window & {
      plausible?: (name: string, options?: { props?: Record<string, string> }) => void;
    }
  ).plausible;
  plausible?.(event, props ? { props } : undefined);
}
